/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing portal related components.
 * @module CportalModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import {
    ClrFormsModule,
    ClrInputModule,
    ClrSpinnerModule,
} from '@clr/angular';

import { AviCardModule, AviDashboardModule } from 'nsx-alb-ui-components';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { AviProxyModule } from 'ng/modules/avi-proxy/avi-proxy.module';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'ng/modules/core/core.module';
import { DashboardModule } from 'ng/modules/dashboard/dashboard.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { FormsModule } from '@angular/forms';
import { LetModule } from '@ngrx/component';
import { SharedModule } from 'ng/shared/shared.module';

import { DialogModule } from '../dialog/dialog.module';

import {
    CloudWidgetComponent,
    CPortalInfoModalComponent,
    CPortalInfoPreviewComponent,
    CPortalPageComponent,
    CPortalPageStore,
    ProxyWidgetComponent,
    SmartOperationsWidgetComponent,
    SplitProxyConfigurationComponent,
    ThreatIntelligenceWidgetComponent,
} from '.';

const cPortalComponents = [
    CloudWidgetComponent,
    CPortalInfoModalComponent,
    CPortalInfoPreviewComponent,
    CPortalPageComponent,
    ProxyWidgetComponent,
    SmartOperationsWidgetComponent,
    SplitProxyConfigurationComponent,
    ThreatIntelligenceWidgetComponent,
];

@NgModule({
    declarations: [
        ...cPortalComponents,
    ],
    imports: [
        AviCardModule,
        AviDashboardModule,
        AviFormsModule,
        AviProxyModule,
        BrowserModule,
        ClrFormsModule,
        ClrInputModule,
        ClrSpinnerModule,
        CommonModule,
        CoreModule,
        DashboardModule,
        DataGridModule,
        DialogModule,
        FormsModule,
        LetModule,
        SharedModule,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA,
    ],
    providers: [
        CPortalPageStore,
    ],
})
export class CportalModule {}
